export default "__VITE_PUBLIC_ASSET__a7c0932a__"